import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../beatriz_martinsstudio/beatriz_martinsstudio.module.scss';
import perfil from '../beatriz_martinsstudio/src/perfil.png';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const cardImages = [
    {
        id: 1,
        image: require("./src/cards/1.png"),
        link: "https://client.tuaagenda.com/c/BeatrizMartins5",
        linkInterno: false,
    },
    {
        id: 2,
        image: require("./src/cards/2.png"),
        link: "/beatriz_martinsstudio/curso",
        linkInterno: false,
    },
    {
        id: 3,
        image: require("./src/cards/3.png"),
        link: "/beatriz_martinsstudio/procedimentos",
        linkInterno: true,
    },
    {
        id: 4,
        image: require("./src/cards/4.png"),
        link: "https://www.instagram.com/beatriz_martinsstudio?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
        linkInterno: true,
    },
];

const Beatriz_martinsstudio: React.FC = () => {
    const whatsappLink = `https://wa.me/5517992254400?text=${encodeURIComponent(
        'Olá! Vim pelo seu cartão digital e gostaria de tirar uma dúvida.'
    )}`;

    return (
        <div className={styles.beatriz_martinsstudio}>
            <div className={styles.container}>
                <img src={perfil} alt="Perfil" className={styles.perfil} />
                <div className={styles.cards}>
                    {cardImages.map((card, index) =>
                        card.linkInterno ? (
                            <Link to={card.link} key={index} className={styles.card}>
                                <img src={card.image} alt={`Card ${card.id}`} />
                            </Link>
                        ) : (
                            <a href={card.link} target="_blank" rel="noopener noreferrer" key={index} className={styles.card}>
                                <img src={card.image} alt={`Card ${card.id}`} />
                            </a>
                        )
                    )}
                </div>

                <div className={styles.footer}>
                    <a
                        href={whatsappLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.footerWhatsapp}
                        aria-label="WhatsApp"
                    >
                        <div className={styles.footerTop}>
                            <WhatsappIcon height="32" color="#111" />
                            <span className={styles.footerText}>Para mais informações<br />Entre em contato pelo WhatsApp</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Beatriz_martinsstudio;
